var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7838 3.52013L6.06906 10.0226C5.19541 10.3845 5.20423 11.6257 6.08383 11.9743L21.864 18.232C23.2505 18.7819 24.7946 18.7819 26.1811 18.232L41.9615 11.9743C42.8406 11.6257 42.8499 10.3845 41.9758 10.0228L26.2616 3.52013C24.8279 2.92688 23.2174 2.92688 21.7838 3.52013Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4229 21.6494V37.2824C25.4229 38.0257 26.1726 38.5351 26.8638 38.2611L44.4477 31.4358C44.6439 31.3581 44.8121 31.2232 44.9306 31.0487C45.0491 30.8742 45.1125 30.6681 45.1124 30.4571V14.8244C45.1124 14.0808 44.3627 13.5717 43.6715 13.8456L26.0876 20.6709C25.8915 20.7487 25.7233 20.8836 25.6048 21.0581C25.4863 21.2326 25.4229 21.4384 25.4229 21.6494Z",
    fill: "#31C2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3169 22.4564L16.0983 24.976L15.5685 25.2322L4.55247 30.5105C3.85441 30.8474 2.96289 30.3385 2.96289 29.5628V14.8901C2.96289 14.6095 3.10679 14.3672 3.29977 14.1849C3.37894 14.1061 3.46876 14.0387 3.56661 13.9848C3.82963 13.8269 4.2051 13.7847 4.52435 13.911L21.2292 20.5299C22.0783 20.8668 22.145 22.0563 21.3169 22.4564Z",
    fill: "#ED314A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3169 22.4564L16.0984 24.976L3.2998 14.1847C3.37899 14.106 3.46881 14.0387 3.56664 13.9848C3.82966 13.8269 4.20514 13.7847 4.52439 13.911L21.2292 20.5299C22.0783 20.8668 22.1451 22.0563 21.3169 22.4564Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.6492,
    height: 40.5018,
    fill: "white",
    transform: "translate(0.33252 0.574219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo6.55f67e2814940dd00dcfb3d28c2cdd9c.svg";
export { ForwardRef as ReactComponent };